import React, { useEffect, useRef, useState } from 'react';

type Props = {
  src: string;
};
const LoopingVideo = ({ src }: Props) => {
  const ref = useRef<HTMLVideoElement>(null);
  const [show, setShow] = useState(false);

  // Display the video only if BB is visible (useful for A/B testing of blocks with video).
  useEffect(() => {
    if (!ref.current) {
      return;
    }

    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          // If BB became visible, then display video and disconnect observer.
          if (ref.current?.checkVisibility()) {
            setShow(true);
            observer.disconnect();
          }
        }
      }
    });

    // If element is visible and screen width >= 768px, then just display the video.
    if (ref.current.checkVisibility()) {
      if (window.matchMedia && window.matchMedia('(min-width: 768px)').matches) {
        setShow(true);
      }
    }
    // Otherwise run an observer to monitor when BB included this video will be visible.
    else {
      observer.observe(document.body, { attributes: true });
    }

    return () => {
      observer.disconnect();
    };
  }, [ref]);

  return (
    <video autoPlay muted loop ref={ref}>
      {show && <source src={src} type="video/mp4" />}
    </video>
  );
};

export default LoopingVideo;
